// hooks/province/reducer.js
export const ACTIONS = {
    SET_LOADING: 'SET_LOADING',
    SET_ERROR: 'SET_ERROR',
    CLEAR_ERROR: 'CLEAR_ERROR',
    SET_PROVINCES: 'SET_PROVINCES',
    SET_SELECTED_PROVINCE: 'SET_SELECTED_PROVINCE',
    ADD_PROVINCE: 'ADD_PROVINCE',
    UPDATE_PROVINCE: 'UPDATE_PROVINCE',
    DELETE_PROVINCE: 'DELETE_PROVINCE',
    SET_FILTER: 'SET_FILTER',
    SET_SORT: 'SET_SORT',
    SET_PAGE: 'SET_PAGE'
};

export const initialState = {
    provinces: [],
    selectedProvince: null,
    loading: false,
    error: null,
    filter: {
        name: null,
        code: null,
        region: null,
        status: null
    },
    pagination: {
        page: 0,
        size: 10,
        total: 0
    },
    sort: {
        field: 'name',
        direction: 'asc'
    },
    lastUpdated: null
};

export const provinceReducer = (state, action) => {
    switch (action.type) {
        case ACTIONS.SET_LOADING:
            return {
                ...state,
                loading: action.payload
            };

        case ACTIONS.SET_ERROR:
            return {
                ...state,
                error: action.payload,
                loading: false
            };

        case ACTIONS.CLEAR_ERROR:
            return {
                ...state,
                error: null
            };

        case ACTIONS.SET_PROVINCES:
            return {
                ...state,
                provinces: action.payload.content,
                pagination: {
                    ...state.pagination,
                    total: action.payload.totalElements || action.payload.length,
                    page: action.payload.number || 0
                },
                lastUpdated: new Date().toISOString(),
                loading: false
            };

        case ACTIONS.SET_SELECTED_PROVINCE:
            return {
                ...state,
                selectedProvince: action.payload,
                loading: false
            };

        case ACTIONS.ADD_PROVINCE:
            return {
                ...state,
                provinces: [action.payload, ...state.provinces],
                lastUpdated: new Date().toISOString(),
                loading: false
            };

        case ACTIONS.UPDATE_PROVINCE:
            return {
                ...state,
                provinces: state.provinces.map((province) => (province.id === action.payload.id ? action.payload.data : province)),
                selectedProvince: state.selectedProvince?.id === action.payload.id ? action.payload.data : state.selectedProvince,
                lastUpdated: new Date().toISOString(),
                loading: false
            };

        case ACTIONS.DELETE_PROVINCE:
            return {
                ...state,
                provinces: state.provinces.filter((province) => province.id !== action.payload),
                selectedProvince: state.selectedProvince?.id === action.payload ? null : state.selectedProvince,
                lastUpdated: new Date().toISOString(),
                loading: false
            };

        case ACTIONS.SET_FILTER:
            return {
                ...state,
                filter: {
                    ...state.filter,
                    ...action.payload
                },
                pagination: {
                    ...state.pagination,
                    page: 0
                }
            };

        case ACTIONS.SET_SORT:
            return {
                ...state,
                sort: action.payload
            };

        case ACTIONS.SET_PAGE:
            return {
                ...state,
                pagination: {
                    ...state.pagination,
                    ...action.payload
                }
            };

        default:
            return state;
    }
};
